import React, { useEffect, useMemo, useState } from "react";
import Grid from "@mui/material/Grid";
import PersonalInfo from "./PersonalInfo";
import MySubscriptions from "./MySubscriptions";
import MyTransaction from "./MyTransaction";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { customer_details } from "../../actions/customer";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

export default function CustomerDetail() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate()
  const customer = useSelector((state) => state.customers.customer);
  const transaction = useSelector((state) => state?.transaction?.create_data);
  const [openApproval, setOpenApproval] = useState(false);
  // console.log(customer?.customer, "cccccc");
  // const id = location.state?.id;
  useEffect(() => {
    if (location.state?.id) {
      dispatch(customer_details({ id: location.state?.id }));
    }
  }, [location]);
  useMemo(() => {
    if (transaction?.statuscode == 200) {
      setTimeout(() => {
        dispatch(customer_details({ id: location.state?.id }));
        setOpenApproval(true);
      }, 1000);
    }
  }, [transaction]);
  const handleClose = () => {
    setOpenApproval(false);
  };
  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={openApproval}
        autoHideDuration={1500}
        onClose={handleClose}
      >
        <Alert severity="info" variant="filled" color="success">
          {transaction?.message}
        </Alert>
      </Snackbar>
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 2 }}
      >
         <Grid item xs={12} md={12} lg={12} xl={12} textAlign={"right"} sx={{mr:"0.5rem"}}>
         <Button
            type={"button"}
            variant="contained"
            style={{
              background:
                "linear-gradient(225deg,  var(--gradientColor1) 0%, var(--gradientColor2) 91.25%)",
            }}
            sx={{
              mb: 1,
              textTransform: "capitalize",
              borderRadius: "8px",
              fontWeight: "500",
              fontSize: "13px",
              padding: "12px 20px",
              minWidth: "0",
              minHeight: "0",
              color: "#fff !important",
            }}
            onClick={() =>
              customer?.customer && navigate("/Sales/Sales", { state: { cus_id: customer?.customer?.id ,cus : customer?.customer } })
            }
          >
           Generate Bill
          </Button>
          </Grid>
        <Grid item xs={12} md={12} lg={12} xl={12}>
          <PersonalInfo data={customer?.customer} />
          <MyTransaction
            data={customer?.transaction_history}
            cus_name={customer?.customer?.name}
            cus_id={customer?.customer?.id}
            total_sales={customer?.total_amount}
            recevied_amount={customer?.total_transaction}
            pendding_amount={customer?.pending_amount}
          />

          <MySubscriptions
            data={customer?.product_list}
            cus_id={customer?.customer?.id}
            cus={customer?.customer}
         
          />
        </Grid>
      </Grid>
    </>
  );
}
